
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/audience-snapshots",
      function () {
        return require("private-next-pages/customer-studio/audience-snapshots.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/audience-snapshots"])
      });
    }
  